import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  ListItemButton,
  // Box,
} from "@mui/material";
import { styled } from "@mui/system";
import React from "react";
import { useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DashboardIcon from "@mui/icons-material/Dashboard";
// import AdminModules from "./AdminModules";
import MuiDrawer from "@mui/material/Drawer";
// import CDAModules from "./CDAModules";
import withAuth from "../../../Hoc/withAuth";
import { DASHBOARD_SECTIONS } from "./moduleOptions";
// import RMAModule from "./RMAModule";

const DrawerMain = ({
  open,
  setOpen,
  user,
  theme,
  companyDetails,
  modules,
}) => {
  const navigate = useNavigate();

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const renderSections = () => {
    // console.log("User Modules:", modules);
    const isAdmin = user?.user_type?.type === "admin";

    return Object.entries(DASHBOARD_SECTIONS).map(([key, section]) => {
      // Check if user has access to this section
      if (!section.checkAccess(modules, isAdmin)) {
        return null;
      }

      return (
        <React.Fragment key={key}>
          {/* Section Title */}
          {open && (
            <ListItem>
              <ListItemText>
                <Typography variant="subtitle2" color="textSecondary">
                  {section.title}
                </Typography>
              </ListItemText>
            </ListItem>
          )}

          {/* Section Features */}
          {section.features.map((feature) => {
            // Check if user has access to this feature
            if (
              (!isAdmin && !modules?.some((m) => feature.module.includes(m))) ||
              (isAdmin && feature.hideFromAdmin)
            ) {
              return null;
            }

            return (
              <ListItemButton
                key={feature.link}
                selected={window.location.pathname === feature.link}
                onClick={() => navigate(feature.link)}
                sx={{ pl: open ? 2 : "auto" }}
              >
                <ListItemIcon>
                  <feature.icon />
                </ListItemIcon>
                {open && (
                  <ListItemText>
                    <Typography>{feature.title}</Typography>
                  </ListItemText>
                )}
              </ListItemButton>
            );
          })}
          <Divider sx={{ my: 1 }} />
        </React.Fragment>
      );
    });
  };

  return (
    <>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader sx={{ backgroundColor: "background.paper" }}>
          {open && (
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          )}
        </DrawerHeader>

        <List>
          {/* Dashboard */}
          <ListItemButton
            selected={window.location.pathname === "/"}
            onClick={() => navigate("/")}
          >
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            {open && (
              <ListItemText>
                <Typography>Dashboard</Typography>
              </ListItemText>
            )}
          </ListItemButton>

          <Divider sx={{ my: 1 }} />

          {/* Company Check Message */}
          {/* {open && checkCompany()} */}

          {/* Dynamic Sections */}
          {companyDetails && renderSections()}
        </List>
      </Drawer>
    </>
  );
};

export default withAuth(DrawerMain);

const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,

  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "background.default",
  boxSizing: "border-box",
  elevation: 0,
  border: "none",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  boxSizing: "border-box",
  elevation: 0,
  backgroundColor: "transparent",
  border: "none",
  width: 0,
  [theme.breakpoints.up("sm")]: {
    width: 0,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end", // Change to flex-end to position icon on the right
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  zIndex: theme.zIndex.drawer + 1, // Add zIndex to ensure icon stays on top
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  elevation: 0,
  border: "none",
  visibility: open ? "visible" : "hidden",
  zIndex: theme.zIndex.drawer, // Add zIndex for proper layering

  "& .MuiDrawer-paper": {
    position: "relative", // Add position relative
    ...(open ? openedMixin(theme) : closedMixin(theme)),
  },

  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
